import React from "react";
import PropTypes from "prop-types";
import muiThemeable from "material-ui/styles/muiThemeable";
import {Table, TableHeader, TableRow} from "material-ui/Table";
import DatagridHeaderCell from "../admin-on-rest/src/mui/list/DatagridHeaderCell";
import DatagridBody from "./ReferenceSelectGridBody";
import {concat, uniq, without} from "lodash";

const defaultStyles = {
  table: {
    tableLayout: "auto"
  },
  tbody: {
    height: "inherit"
  },
  header: {
    th: {
      padding: 0
    },
    "th:first-child": {
      padding: "0 0 0 12px"
    }
  },
  cell: {
    td: {
      padding: "0 12px",
      whiteSpace: "normal"
    },
    "td:first-child": {
      padding: "0 12px 0 16px",
      whiteSpace: "normal"
    }
  }
};

class ReferenceSelectGrid extends React.Component {
  constructor() {
    super();
    this.state = {
      data: {},
      ids: [],
      filter: {},
      pagination: {
        page: 1,
        perPage: 10
      }
    };
  }

  updateSort = e => {
    // Get sort field name from event's attributes (see DatagridHeaderCell implementation)
    const field = e.currentTarget.attributes["data-sort"].value;

    // Sort order: only set to DESC if we're currently sorting by same field ASC
    const sort = {
      field: field,
      order:
        this.props.sort.field === field && this.props.sort.order === "ASC"
          ? "DESC"
          : "ASC"
    };

    this.props.setSort(sort);
  };

  onRowSelection = selectedRows => {
    const {input, choices} = this.props;
    const choiceIds = choices.map(c => c.id);

    // Need to map from selected row indexes to ids and callback the
    // passed in handler - if defined
    if (typeof input.onChange !== "function") {
      return;
    }

    if (selectedRows === "all") {
      // when selecting all, we get string "all" for selection
      input.onChange(uniq(concat(input.value, choiceIds)));
    } else if (selectedRows === "none") {
      // when deselecting all, we get string "none"
      input.onChange(without(input.value, ...choiceIds));
    } else {
      // after clicking on a checkbox, we get a list of selected row indices - in this case it is always an array, either an empty one, or containing all row indices, unlike previous 2 cases
      const selectedIds = selectedRows.map(rowIdx => choices[rowIdx].id);
      const notSelectedIds = without(choiceIds, ...selectedIds);
      const acc = input.value === "" ? [] : input.value ;
      input.onChange(
        without(uniq(concat(acc, selectedIds)), ...notSelectedIds)
      );
    }
  };

  render() {
    const {
      resource,
      children,
      isLoading,
      styles = defaultStyles,
      muiTheme,
      rowStyle,
      options,
      headerOptions,
      bodyOptions,
      rowOptions,
      basePath,
      sort
    } = this.props;

    // We got setFilter, setSort and setPagination from parent

    // sort received from ReferenceArrayInput is an object with keys field and
    // order; grid expects object with fields sort and order
    const currentSort = sort;

    const data = this.props.choices.reduce((acc, item) => {
      acc[item.id] = item;
      return acc;
    }, {});
    const ids = this.props.choices.map(item => item.id);
    const selectedIDs = this.props.input ? this.props.input.value : "none";

    const updateSort = this.updateSort;

    if (options.onRowSelection === undefined) {
      options.onRowSelection = this.onRowSelection;
    }

    return (
      <Table
        style={options && options.fixedHeader ? null : styles.table}
        fixedHeader={false}
        {...options}
      >
        <TableHeader
          displaySelectAll={false}
          adjustForCheckbox={false}
          {...headerOptions}
        >
          <TableRow style={muiTheme.tableRow}>
            {React.Children.map(children, (field, index) => {
              return field ? (
                <DatagridHeaderCell
                  key={field.props.source || index}
                  field={field}
                  defaultStyle={
                    index === 0
                      ? styles.header["th:first-child"]
                      : styles.header.th
                  }
                  currentSort={currentSort}
                  isSorting={field.props.source === currentSort.field}
                  updateSort={updateSort}
                  resource={resource}
                />
              ) : null;
            })}
          </TableRow>
        </TableHeader>
        <DatagridBody
          resource={resource}
          ids={ids}
          data={data}
          basePath={basePath}
          styles={styles}
          rowStyle={rowStyle}
          isLoading={isLoading}
          options={bodyOptions}
          rowOptions={rowOptions}
          selected={selectedIDs}
        >
          {children}
        </DatagridBody>
      </Table>
    );
  }
}

ReferenceSelectGrid.propTypes = {
  basePath: PropTypes.string,
  bodyOptions: PropTypes.object,
  currentSort: PropTypes.shape({
    sort: PropTypes.string,
    order: PropTypes.string
  }),
  data: PropTypes.object.isRequired,
  headerOptions: PropTypes.object,
  ids: PropTypes.arrayOf(PropTypes.any).isRequired,
  isLoading: PropTypes.bool,
  muiTheme: PropTypes.object,
  options: PropTypes.object,
  resource: PropTypes.string,
  rowOptions: PropTypes.object,
  rowStyle: PropTypes.func,
  setSort: PropTypes.func,
  styles: PropTypes.object
};

ReferenceSelectGrid.defaultProps = {
  data: {},
  ids: []
};

export default muiThemeable()(ReferenceSelectGrid);



// WEBPACK FOOTER //
// ./src/components/ReferenceSelectGrid.js